import React, {Suspense} from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Load } from './pages'
import './index.css';

import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={<Load />} >
      <App />
    </Suspense>
  </React.StrictMode>
);
